import { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/inputtext/index.ts
const it = componentCommon.inputtext;

export const InputTextTelekomDT: InputTextDesignTokens = {
  root: {
    background: t(it.background),
    disabledBackground: t(it.disabled.background),
    filledBackground: t(it.filled.background),
    filledHoverBackground: t(it.filled.hover.background),
    filledFocusBackground: t(it.filled.focus.background),
    borderColor: t(it.border.color),
    borderRadius: t(it.border.radius),
    hoverBorderColor: t(it.hover.border.color),
    focusBorderColor: t(it.focus.border.color),
    invalidBorderColor: t(it.invalid.border.color),
    color: t(it.color),
    disabledColor: t(it.disabled.color),
    placeholderColor: t(it.placeholder.color),
    invalidPlaceholderColor: t(it.invalid.placeholder.color),
    paddingX: t(it.padding.x),
    paddingY: t(it.padding.y),
    focusRing: {
      width: t(it.focus.ring.width),
      color: t(it.focus.ring.color),
      offset: t(it.focus.ring.offset),
    },
    sm: {
      fontSize: t(it.sm.font.size),
      paddingX: t(it.sm.padding.x),
      paddingY: t(it.sm.padding.y),
    },
    lg: {
      fontSize: t(it.lg.font.size),
      paddingX: t(it.lg.padding.x),
      paddingY: t(it.lg.padding.y),
    },
  },
};
